import React, { Component } from 'react';

import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsGroupObjectBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">The group object</div>
          <APIDocsTable
            title="Attributes"
            rows={[
              {
                heading: 'id',
                subheading: 'string',
                description: 'A unique identifier for the group.',
              },
              {
                heading: 'name',
                subheading: 'string',
                description: 'The name of the group.',
              },
              {
                heading: 'description',
                subheading: 'string',
                description: 'A short description of what this group represents.',
              },
              {
                heading: 'urlName',
                subheading: 'string',
                description: 'A URL-friendly identifier for the group.',
              },
            ]}
          />
        </div>
        <div>
          <div className="text">Example group object:</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba12bb",
  "name": "Product",
  "description": "All ideas related to the product surface area.",
  "urlName": "product"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
